<template>
  <div class="about">
    <commonHeader>
      <img slot="content" class="header-bg" :src="bannerImg | imgFilter" v-if="bannerImg" />
      <banner-content
        slot="content"
        title="关于我们"
        en-title="ABOUT US"
        content="拥有一支丰富信息化项目经验的专业团队， 能够以最短的时间开发出高性能的产品，使用最前沿技术分布式、 微服务、人工智能算法等，为我们的客户提供最佳解决方案"
      />
    </commonHeader>
    <!-- 关于我们 -->
    <vue-lazy-component>
      <com-about></com-about>
      <skeleton slot="skeleton" ></skeleton>
    </vue-lazy-component>
    <!-- 旗下子公司 -->
    <vue-lazy-component>
      <subsidiary></subsidiary>
      <skeleton slot="skeleton" ></skeleton>
    </vue-lazy-component>
    <!-- 企业环境 -->
    <vue-lazy-component>
      <environment></environment>
      <skeleton slot="skeleton" ></skeleton>
    </vue-lazy-component>
  </div>
</template>
<script>
import commonHeader from "@/components/commonHeader.vue";
import comAbout from "./components/com-about.vue";
import subsidiary from "./components/subsidiary.vue";
import environment from "./components/environment.vue";
import bannerContent from "@/components/bannerContent.vue";
import { mapActions, mapGetters } from "vuex";
import skeleton from "@/components/skeleton";
export default {
  components: {
    commonHeader,
    comAbout,
    subsidiary,
    environment,
    skeleton,
    bannerContent
  },
  computed: {
    ...mapGetters("banner", ["banner"]),
    bannerImg() {
      let arr = this.banner(1);
      return arr.length ? arr[0].carousel_image : "";
    }
  },
  methods: {
    ...mapActions("banner", ["getBanner"])
  },
  created() {
    if (!this.banner(1).length) this.getBanner(1);
  }
};
</script>
<style lang="scss" scoped>
@import url("~@/assets/css/common.scss");
.about {
  width: 100%;
  .header-bg {
    width: 100%;
    vertical-align: top;
  }
}
</style>
